import deephowApiServerWrapper from "@/server/api-server";
import environment from "../../env";
import axios from "axios";
import Vue from "vue";

export async function syncPrivatePlayerTrackingToServer({ trackingInfo }) {
  const payload = {
    ...trackingInfo,
    location: {},
  };
  const { ok, data, errorMessage } = await deephowApiServerWrapper("post", "/v1/tracking", payload);
  if (ok) {
    return { ok: true, data };
  } else {
    const customErrorMessage = `Failed to sync Private player tracking info to server - error: ${errorMessage}`;
    console.log(customErrorMessage);
    return { ok: false, errorMessage: customErrorMessage };
  }
}

function getBaseUrl() {
  return environment.backendType === "firebase"
    ? environment.service[environment.env].deephowApiServer
    : environment.service[environment.env]["china"].deephowApiServer;
}

const publicVideoTracker = axios.create({
  baseURL: getBaseUrl(),
});

export async function syncPublicPlayerTrackingToServer({ trackingInfo }) {
  try {
    const payload = {
      ...trackingInfo,
      location: {},
    };
    const { status, statusText } = await publicVideoTracker.post("/v1/tracking", payload);
    const isSuccess = status === 200;
    if (isSuccess) {
      return { ok: true };
    }
    const error = `status: ${status}, statusText: ${statusText}`;
    throw error;
  } catch (error) {
    const errorMessage = `Failed to sync Public player tracking info to server -  error: ${error}`;
    console.log(errorMessage);
    return { ok: false, errorMessage };
  }
}
